import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAouYzJSL_6keEZzqnKRlr0zk7yNplHcG8",
  authDomain: "psycp-app.firebaseapp.com",
  projectId: "psycp-app",
  storageBucket: "psycp-app.firebasestorage.app",
  messagingSenderId: "779108238155",
  appId: "1:779108238155:web:d948e2cdfba121a22c5ece"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();

export default firebase;